<script setup lang="ts">
type EnumData = App.Base.Data.EnumData;
type ApplicationData = App.Students.Data.ApplicationData;
type StudentUserData = App.Auth.Data.StudentUserData;

import CollegeApplicationDataRequestDialog from '@/domains/data-request/components/student/college-applications/CollegeApplicationDataRequestDialog.vue';

defineProps<{
  application: ApplicationData;
  user: StudentUserData;
  statuses: EnumData[];
}>();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <CollegeApplicationDataRequestDialog
    :application="application"
    :statuses="statuses"
    :user="user"
  />
</template>
